// Drawer search entry: close the drawer, then open the search dialog, since a
// dialog opened while the drawer is up renders behind it. Delegated on document
// because the drawer re-renders on section reload in the theme editor.
(function () {
  if (window.bqDrawerExtras) return;
  window.bqDrawerExtras = true;

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-bq-open-search]');
    if (!b) return;
    e.preventDefault();

    // The page shows through for ~300ms between the drawer closing and the dialog
    // opening; the veil sits on the body, the drawer stopping rendering when it closes.
    const veil = document.createElement('div');
    veil.className = 'bq-searchveil';
    veil.setAttribute('aria-hidden', 'true');
    veil.innerHTML =
      '<svg viewBox="0 0 44 44" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round">' +
      '<circle class="bq-searchveil__ring" cx="19" cy="19" r="12"/>' +
      '<path class="bq-searchveil__stem" d="M28 28l9 9"/></svg>';
    document.body.appendChild(veil);
    requestAnimationFrame(() => veil.classList.add('is-on'));
    // Timer rather than transitionend: a missed event would leave an invisible
    // full-screen node swallowing taps.
    setTimeout(() => veil.remove(), 900);

    // The component's own close(), never `details.open = false`: that leaves
    // `.menu-open` on, so the summary keeps its cross and the next tap reopens.
    const drawer = b.closest('header-drawer');
    if (typeof drawer?.close === 'function') drawer.close();
    else b.closest('details.menu-drawer-container')?.removeAttribute('open');

    // showDialog() directly, the theme's declarative binding ignoring synthetic
    // clicks; 320ms lands after the drawer's closing pass, which dismisses dialogs.
    const modal = document.getElementById('search-modal');
    setTimeout(() => {
      if (typeof modal?.showDialog === 'function') modal.showDialog();
      else modal?.querySelector('dialog')?.showModal();
    }, 320);
  });
})();
